/* eslint-disable @typescript-eslint/no-explicit-any */
import { DefaultLayout } from 'layouts';

export type RouteType = {
  path: string;
  component: any;
  layout?: any;
  middlewares: Array<any>;
  children?: Array<RouteType>;
};

/**
 * @deprecated: legacy routing flow. use react-router's suggested routing
 */
export const makeRoute = ({
  path,
  component,
  layout = DefaultLayout,
  middlewares = [],
  children,
}: RouteType): RouteType => ({
  path,
  component,
  layout,
  middlewares,
  children,
});
